import { get as n } from "./get.js";
function e(r) {
  return function (t) {
    return n(t, r);
  };
}
export { e as property };